import * as React from "react";
import { getAccount } from "./global_functions/postgrestApi";
import backpackSdk from "./global_functions/backpackSdk/sdk";
import UserContext from "./context/UserContext";
import { bugsnagGeneralErrorHandler } from "./global_functions/postgrestApi/common";
import { isPendoEnabled } from "./env";
import { identify } from "./telemetry";

export default function IdentifyUserManager() {
  const { currentUser } = React.useContext(UserContext);

  const { mutateAsync: getNominatorName } =
    backpackSdk.nominators.name.useManualQuery();

  React.useEffect(() => {
    if (isPendoEnabled) {
      if (currentUser) {
        const identifyUser = async () => {
          try {
            const nominator = await getNominatorName(currentUser.fromNominator);
            const account = currentUser.accountId
              ? await getAccount(currentUser.accountId)
              : ({ id: -1, name: "Bractlet", accountType: "admin" } as const);

            if (!account)
              throw new Error(
                `No account found for id: ${currentUser?.accountId ?? ""}`
              );

            if (!nominator && currentUser.fromNominator) {
              throw new Error(
                `No nominator found for id: ${currentUser.fromNominator}`
              );
            }

            identify(currentUser, account, nominator);
          } catch (e: any) {
            bugsnagGeneralErrorHandler(e);
          }
        };
        identifyUser();
      }
    }
  }, [currentUser, getNominatorName]);

  return null;
}
